import { DatePicker } from '@mui/x-date-pickers'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

/**
 * Renders a date picker input field within a form.
 * 
 * @author Isadora Botassari, Maria Eduarda Franke
 * @param {string} name - The name of the input field.
 * @param {string} label - The label for the input field.
 * @param {object} control - The control object from react-hook-form.
 * @param {object} errors - The errors object from react-hook-form.
 * @param {object} textFieldProps - Additional props for the text field component.
 * @returns {JSX.Element} - The rendered date picker input field.
 */
const FormInputDate = ({ name, label, control, errors, textFieldProps, ...props }) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <DatePicker
                    {...field}
                    label={label}
                    slotProps={{
                        textField: {
                            error: !!errors,
                            helperText: errors?.message,
                            InputLabelProps: { shrink: true },
                            ...textFieldProps
                        },
                        actionBar: {
                            actions: ['clear']
                        }
                    }}

                    {...props}

                />
            )}
        />
    )
}

FormInputDate.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object,
    textFieldProps: PropTypes.object
}

export default FormInputDate